import { Header } from "@/components/sven/Header";
import { Footer } from "@/components/sven/Footer";
import { PageHero } from "@/components/sven/PageHero";
import { VisitUs } from "@/components/sven/VisitUs";

export default function StoresPage() {
  return (
    <main data-testid="stores-page">
      <Header />
      <PageHero overline="Store Locator" title="Find us on" accent="Swami Vivekanand Road.">
        <p className="mt-6 max-w-xl text-sm sm:text-base font-light leading-relaxed text-white/60">
          Two ateliers, ten minutes apart — Santacruz West and Bandra West.
          Walk-ins welcome, 11 AM to 9 PM, every day of the week.
        </p>
      </PageHero>
      <VisitUs />
      <Footer />
    </main>
  );
}
